<template>
  <div>
    <top-head />
    <video-part></video-part>
    <title-bar title="员工风采"></title-bar>
    <div class="people-box">
      <el-row>
        <el-col :span="8">
          <img src="../../../static/images/life/people1.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people2.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people3.jpg">
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <img src="../../../static/images/life/people4.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people5.jpg">
        </el-col>
        <el-col :span="8">
          <img src="../../../static/images/life/people6.jpg">
        </el-col>
      </el-row>
    </div>
    <div class="word-box">
      <img src="../../../static/images/life/wordbg.jpg" />
      <div class="word-center-box">
        <div class="word-center">
          <div class="word-title">
            BE BETTA BE BETTER
          </div>
          <div class="word-content">
            贝塔秉持“BE BETTA BE
            BETTER”的雇主品牌主张，坚持简单、快速、负责的工作理念，为旗下广大游戏人才提供丰厚的价值回报、完善的福利保障以及求真务实、鼓励创新的组织文化空间，以此来真正迎接广大热爱游戏行业、充满创业激情的优秀人才，最大限度发挥才能，实现职业梦想，创造美好生活，以最终实现千万日活，亿万笑脸的美好愿景
          </div>
        </div>
      </div>
    </div>
    <div class="spread-box">
      <el-row>
        <el-col :span="16">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread1-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread1-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread1-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word">
            <div class="spreadBox">
                <div class="spread-word-title">BETTA PARTY</div>
                <div class="spread-word-content">多样社团、生日party、节日礼包，满足全体员工的身心健康与风险保障，快乐工作，快乐成长</div>
            </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16" class="spread-img-right">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread2-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread2-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread2-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word spread-word2">
            <div class="spreadBox">
                <div v-show="imgSwitch == 1" class="spread-word-title">基础福利</div>
                <div v-show="imgSwitch == 1" class="spread-word-content">“让关怀细致入微，让福利落到实处”
                    ，全额五险一金、年度体检、餐补、下午茶、零食，确保福利足够丰富、全面、实用</div>
                <div v-show="imgSwitch == 2" class="spread-word-title">个性福利平台</div>
                <div v-show="imgSwitch == 2" class="spread-word-content">
                    除基本福利外，我们正在搭建福利自选平台，以满足员工住房、教育、饮食以及为子女、父母、配偶的风险保障等个性化需求</div>
                <div v-show="imgSwitch == 3" class="spread-word-title">BEAUTIFUL LIFE</div>
                <div v-show="imgSwitch == 3" class="spread-word-content">我们做了股权激励、高端医疗、家庭旅行、长期贡献奖、终身成长学习基金等特别定制版福利，
                    以感恩与回馈长期陪伴贝塔成长的员工以及背后的家人们</div>
            </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <img v-show="imgSwitch == 1" src="../../../static/images/life/spread3-1.jpg" />
          <img v-show="imgSwitch == 2" src="../../../static/images/life/spread3-2.jpg" />
          <img v-show="imgSwitch == 3" src="../../../static/images/life/spread3-3.jpg" />
        </el-col>
        <el-col :span="8" class="spread-word">
            <div class="spreadBox" style="width:250px;">
                <div class="spread-word-title">Team Building</div>
                <div class="spread-word-content">专享团建津贴，更有爱，也要有个性</div>
            </div>
        </el-col>
      </el-row>
    </div>
    <homeFoot />
  </div>
</template>
<script>
  import topHead from '../parts/headPart';
  import homeFoot from '../parts/homeFoot.vue';
  import videoPart from '../parts/life/videoPart.vue';
  import TitleBar from '../common/title-bar.vue';

  export default {
    name: 'life',
    components: {
      topHead,
      homeFoot,
      videoPart,
      TitleBar
    },
    data() {
      return {
        imgSwitch: 1
      }
    },
    mounted() {
      setInterval(() => {
        if (this.imgSwitch == 3) {
          this.imgSwitch = 1
        } else {
          this.imgSwitch += 1
        }
      }, 7000)
    }
  }
</script>
<style scoped lang="less">
  .people-box {
    width: 100%;

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .word-box {
    width: 100%;
    color: #fff;
    position: relative;

    img {
      width: 100%;
      vertical-align: middle;
    }

    .word-center-box {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .word-title {
        font-size: 36px;
        line-height: 36px;
      }

      .word-content {
        font-size: 18px;
        width: 1080px;
        margin: 0 auto;
        margin-top: 50px;
        line-height: 32px;
      }
    }
  }

  .spread-box {
    width: 100%;

    img {
      width: 100%;
      min-width: 976px;
      vertical-align: middle;
    }

    .spread-word {
      height: 100%;
      position: absolute;
      right: 0;
      background-color: #47A3E4;
      color: #fff;
      text-align: left;
      display: flex;
      justify-content: center;
      flex-direction: column;
        .spreadBox{
            height:100%;
            margin: 50% auto;
            width:340px;
        }
      .spread-word-title {
        font-size: 28px;
        line-height: 28px;
      }

      .spread-word-content {
        width: 340px;
        font-size: 16px;
        line-height: 32px;
        margin-top: 18px;
      }
    }

    .spread-word2 {
      left: 0;

      .spread-word-title {
        font-size: 28px;
        line-height: 28px;
      }

      .spread-word-content {
        width: 340px;
        font-size: 16px;
        line-height: 32px;
        margin-top: 18px;
      }
    }

    .spread-img-right {
      float: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/life.vue